import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { MenuProvider } from './contexts/MenuContext';
import { NotificationProvider } from './contexts/NotificationContext';
import { ThemeProvider } from './contexts/ThemeContext';
import './App.css';
import AppRoutes from './Routes';

function App() {
  return (
    <Router>
      <ThemeProvider>
        <NotificationProvider>
          <MenuProvider>
            <AppRoutes />
          </MenuProvider>
        </NotificationProvider>
      </ThemeProvider>
    </Router>
  );
}

export default App;
